// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"25003e33","945":"25003e33"}[chunkId] + ".chunk.css";
};